class CustomPermissionModalService {
    constructor(
        $http,
        appConfig
    ) {
        'ngInject';

        this.$http = $http;
        this.appConfig = appConfig;
    }

    updateUser(userId, permissions) {
        const data = {
            custom_permission_ids: permissions
        };
        return this.$http.patch(`${this.appConfig.apiUrl}/users/${userId}/`, data)
            .then((successResponse) => successResponse.data);

    }

}

export default CustomPermissionModalService;


// WEBPACK FOOTER //
// ./app/components/user-admin/custom-permission-modal/custom-permission-modal-service.js